// extracted by mini-css-extract-plugin
var _1 = "FieldVariableCard-modulecard__MCKUs";
var _2 = "FieldVariableCard-moduletitle__J1YCQ";
export { _1 as "card", _2 as "title" }
